const Range = (length: number, startIndex: number = 0) =>
  Array.from(new Array(length)).map((_, index) => index + startIndex);

export interface SkeletonArrayType {
  id: number;
}

// eslint-disable-next-line no-magic-numbers
const SkeletonArray = (length: number = 5): SkeletonArrayType[] =>
  Array.from(new Array(length)).map((_, index) => ({ id: index }));

export default { Range, SkeletonArray };
